document.addEventListener("DOMContentLoaded", function () {
  const filterForm = document.querySelector('form[data-filter-form]');
  const productGridContainer = document.querySelector('#ProductGridContainer');

  if (!filterForm || !productGridContainer) return;

  filterForm.addEventListener("change", function () {
    const formData = new FormData(filterForm);
    const params = new URLSearchParams(formData).toString();

    fetch(`${window.location.pathname}?${params}`, {
      headers: { "X-Requested-With": "XMLHttpRequest" }
    })
      .then((res) => res.text())
      .then((html) => {
        const newDocument = new DOMParser().parseFromString(html, "text/html");
        const newGrid = newDocument.querySelector("#ProductGridContainer");

        if (newGrid) {
          productGridContainer.innerHTML = newGrid.innerHTML;
          window.history.replaceState({}, "", `${window.location.pathname}?${params}`);
        }
      });
  });
});
